export const STATE_DISABLED = "DISABLED";
export const STATE_ENABLED = "ENABLED";

export const calculateTotalPages = (items, rowsPerPage) => {
  return Math.ceil(items.length / rowsPerPage);
};

export const getRowsForPage = (items, page, rowsPerPage) => {
  // Display only the appropriate portion of element for current page
  const customFieldsReduced = [...items];
  customFieldsReduced.splice(0, page * rowsPerPage);

  customFieldsReduced.splice(
    page * rowsPerPage + rowsPerPage,
    items.length - 1,
  );

  return customFieldsReduced;
};
